import { useEffect } from "react";
import { useLocation } from "react-router";
import { resolvePageMetadata } from "./seo-data";
import { updateDocumentMetadata } from "./seo-head";

export const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    updateDocumentMetadata(resolvePageMetadata(pathname));
  }, [pathname]);

  return null;
};
